import { render, staticRenderFns } from "./ManageDecisionForm.vue?vue&type=template&id=07ddabd8&"
import script from "./ManageDecisionForm.vue?vue&type=script&lang=js&"
export * from "./ManageDecisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports